































































































import { Component, Ref, Vue } from 'vue-property-decorator';
import AuthModule from '@/store/modules/auth.module';
import Config from '@/config.json';
import PrivacyPolicyModal from '@/views/support/PrivacyPolicyModal.vue';
import RegistrationModule from '@/store/modules/registration.module';
import TaftSupportModal from '@/views/support/TaftSupportModal.vue';
import { getModule } from 'vuex-module-decorators';

@Component({
  components: {
    TaftSupportModal,
    PrivacyPolicyModal,
  },
})
export default class Home extends Vue {
  private registrationModule = getModule(RegistrationModule, this.$store);
  private authModule = getModule(AuthModule, this.$store);
  private envName: string = Config.VUE_APP_ENV_TEST || 'default';
  @Ref()
  readonly supportModal!: TaftSupportModal;
  @Ref()
  readonly privacyModal!: PrivacyPolicyModal;

  createAccount() {
    this.registrationModule.startRegistration();
    this.$router.push('/create-account');
  }

  login() {
    this.authModule.login({ redirectPath: '/main' });
  }

  loginIdir() {
    this.authModule.login({
      redirectPath: '/ministry',
      options: { extraQueryParams: { kc_idp_hint: 'idir' } },
    });
  }

  contactUs() {
    this.supportModal.show();
  }

  privacyPolicy() {
    this.privacyModal.show();
  }
}
